const UnusualActivityTypes = {
  multiple: {
    title: 'Multiple Detection Types',
    description: 'Multiple unusual activity patterns detected simultaneously.',
  },
  bot_behavior: {
    title: 'Bot Behavior',
    description: 'Statistical patterns indicate automated or bot-like input behavior.',
  },
  suspicious_app: {
    title: 'Suspicious Application',
    description: 'Known time fraud or automation application detected running on the system.',
  },
  high_activity: {
    title: 'Unusually High Activity',
    description: 'Activity rate was 95%+ for an extended period (e.g., 30+ minutes).',
  },
  consistent_activity: {
    title: 'Unusually Consistent Activity',
    description: 'Activity rate varied 1-4% for over 90 minutes, or 0% variance for 40+ minutes.',
  },
  low_keyboard_input: {
    title: 'Low Keyboard Input',
    description: 'Keyboard activity near 0% while mouse is active for 50+ minutes.',
  },
  low_mouse_input: {
    title: 'Low Mouse Input',
    description: 'Mouse activity near 0% while keyboard is active for 50+ minutes.',
  },
  high_focus_time: {
    title: 'Sustained High Focus Time',
    description: 'Member remained highly focused (80%+ activity) '
      + 'for 5+ hours in a single day, with other unusual activity present.',
  },
};

export {
  UnusualActivityTypes,
};
